export const GRANTED = 'granted';
export const PROMPT = 'prompt';
export const DENIED = 'denied';
export const GEOLOCATION = 'geolocation';
